import './styles/_collection-items.scss';
import Swiper from 'swiper-latest/bundle';
import { initVideo } from '../services/video';

import {
  isScriptFullyLoaded,
  markScriptFullyLoaded,
  onDocumentReady,
} from '../utils/dom';

const state = {
  variables: {
    title: 'collection-items',
    itemsToLoad: document.querySelector('.collection-items')?.getAttribute('data-items-load') || 3,
  },
  elements: {},
};

const cacheState = () => {
  state.elements = {
    collectionItems: document.querySelector('.collection-items'),
    itemsSections: document.querySelectorAll('.collection-items-section-item'),
    loadMoreBtn: document.getElementById("load-more-btn"),
    infiniteBtn: document.getElementById("collection-items-loader"),
    loaderBtn: document.getElementById("collection-items-loader-button"),
    hiddenBlocks: Array.from(document.querySelectorAll(".hidden-block")),
    currentIndex: 0,
  };

  const sections = Array.from(document.querySelectorAll('.collection-items[data-section-id]'));
  state.components = sections.reduce((acc, curr) => {
    const currentComponent = {
      swiperEl: curr.querySelector('.swiper.collection-items-section-item'),
      totalSlides: Array.from(curr.querySelectorAll('.collection-items-section-item .swiper-slide')).length,
      banners: Array.from(curr.querySelectorAll('.collection-items-section-item .swiper-slide')),
    };
    return [...acc, currentComponent];
  }, []);
};

const updateLoadMoreIndex = () => {
  const loadMoreBtn = document.getElementById("load-more-btn");
  const hiddenBlocks = document.querySelectorAll(".hidden-block");
  const infiniteBtn = document.getElementById("collection-items-loader");

  if (hiddenBlocks.length == 0 && loadMoreBtn) {
    loadMoreBtn.classList.add('unvisible');
    state.elements.loaderBtn.classList.remove("visible");
  }

  if (hiddenBlocks.length == 0 && infiniteBtn) {
    infiniteBtn.classList.add('unvisible');
  }
};

const loadMore = () => {
  const { loaderBtn, hiddenBlocks, loadMoreBtn } = state.elements;
  const { itemsToLoad } = state.variables;
  loaderBtn?.classList.add("visible");
  loadMoreBtn?.classList.add('unvisible');
  setTimeout(() => {
    loaderBtn?.classList.remove("visible");
    loadMoreBtn?.classList.remove('unvisible');
    const remainingItems = hiddenBlocks.length - state.elements.currentIndex;
    const itemsToShow = Math.min(itemsToLoad, remainingItems);

    for (let i = 0; i < itemsToShow; i++) {
      hiddenBlocks[state.elements.currentIndex + i].classList.remove("hidden-block");
    }

    state.elements.currentIndex += itemsToShow;

    updateLoadMoreIndex();
  }, 500);
};

const initializeSwiper = () => {
  state.elements.itemsSections?.forEach((swiperContainer) => {
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      navigation: {
        nextEl: swiperContainer.querySelector('.swiper-button-next'),
        prevEl: swiperContainer.querySelector('.swiper-button-prev'),
      },
    });
  });
};

const setupScrollEvent = () => {
  window.addEventListener('scroll', () => {
    const collectionItems = state.elements.collectionItems;
    const lastItem = collectionItems.querySelector('.collection-items-section-item:last-child');
    const lastItemPosition = lastItem.getBoundingClientRect().top + window.scrollY;
    if (window.innerHeight + window.scrollY >= lastItemPosition - 10) {
      if (collectionItems.getAttribute('data-scroll-behaviour') === 'infinite') {
        loadMore();
      }
    }
  });
};

const attachEventListeners = () => {
  if (state.elements.loadMoreBtn) {
    state.elements.loadMoreBtn.addEventListener("click", (e) => {
      e.preventDefault();
      loadMore();
    });
  }

  if (state.elements.collectionItems && state.elements.collectionItems.getAttribute('data-scroll-behaviour') === 'infinite') {
    setupScrollEvent();
  }
};

const init = () => {
  if (isScriptFullyLoaded(state.variables.title)) return;
  markScriptFullyLoaded(state.variables.title);
  cacheState();
  attachEventListeners();
  initializeSwiper();
  initVideo(state.components);
};

onDocumentReady(init);